var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgPlus = function SvgPlus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 16a.832.832 0 0 1-.857-.857V8.857H.857a.833.833 0 0 1-.614-.243A.833.833 0 0 1 0 8a.833.833 0 0 1 .857-.857h6.286V.857A.833.833 0 0 1 8 0a.833.833 0 0 1 .857.857v6.286h6.286A.832.832 0 0 1 16 8a.832.832 0 0 1-.857.857H8.857v6.286A.832.832 0 0 1 8 16Z"
  })));
};

export default SvgPlus;